module.exports = __webpack_public_path__ + "static/media/ShareBtn.f1575c92.svg";